import { isDefined } from "@clipboard-health/util-ts";

export type NumberValidationResult = { isError: true; errorMessage: string } | { isError: false };

export function validateNumberInput(params: {
  value: string | undefined;
  minValue: number;
  maxValue: number;
}): NumberValidationResult {
  const { value, minValue, maxValue } = params;

  if (!isDefined(value) || value === "") {
    return { isError: false };
  }

  const numberValue = Number(value);

  if (!Number.isSafeInteger(numberValue)) {
    return { isError: true, errorMessage: "Please enter a valid number" };
  }

  if (numberValue < minValue || numberValue > maxValue) {
    return {
      isError: true,
      errorMessage: `Please enter a number between ${minValue} and ${maxValue}.`,
    };
  }

  return { isError: false };
}
